import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslate } from "src/locales";

interface ByzNurseDeleteButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
}

const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup }) => ({
  width: "96px",
  height: "36px",

  padding: "4px 10px",
  gap: "6px",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "22px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  border: "1px solid #2979C3",
  backgroundColor: "#63B4FF33",
  color: "#2979C3",
  "&:hover": {
    backgroundColor: "#a72819",
    color: "#fff",
  },
}));

const ByzNurseDeleteButton: React.FC<ByzNurseDeleteButtonProps> = ({ onClick, link, popup, disabled }) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  const buttonContent = (
    <>
      <DeleteIcon
        style={{
          width: "16px",
          height: "16px",
          marginRight: "5px",
          transition: "0.2s ease-in-out",

        }}
      />
      <ByzMuiTypography
        fontWeight={400}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px",
        }}
      >
        {t("buttons.delete")}
      </ByzMuiTypography>
    </>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>
      <StyledButton
        popup={popup}
        disabled={disabled}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      popup={popup}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzNurseDeleteButton;
